import { TodoAppFrom } from '@demind-inc/core';

export const TODO_INTEGRATION_ICONS: Partial<Record<TodoAppFrom, string>> = {
  todoist: require('../../assets/todoIntegrations/todoist_icon.png'),
  trello: require('../../assets/todoIntegrations/trello_icon.png'),
  ticktick: require('../../assets/todoIntegrations/ticktick_icon.jpg'),
  clickup: require('../../assets/todoIntegrations/clickup.png'),
  notion: require('../../assets/todoIntegrations/notion_icon.png'),
  github: require('../../assets/todoIntegrations/github.png'),
  'google-tasks': require('../../assets/todoIntegrations/google-tasks.png'),
  lifestack: require('../../assets/logo/logo_transparent.png'),
  'apple-reminders': require('../../assets/todoIntegrations/apple_reminders.png'),
};
